import { create } from 'zustand';

export const DEMO_MEMBERS = [
  { id: 'anderson', name: 'Anderson', avatar: 'A', status: 'online', role: 'ADMIN', badge: 'Founder', division: 'Foundation', avatarBg: 'from-red-600 via-blue-600 to-orange-400' },
  { id: 'trevor', name: 'Trevor', avatar: 'T', status: 'online', role: 'MODERATOR', badge: 'Foundation', division: 'Foundation', avatarBg: 'from-red-600 to-red-800' },
  { id: 'sarah', name: 'Sarah', avatar: 'S', status: 'online', role: 'MEMBER', badge: 'Labs', division: 'Labs', avatarBg: 'from-orange-400 to-orange-700' },
  { id: 'marcus', name: 'Marcus', avatar: 'M', status: 'in-game', role: 'MODERATOR', badge: 'Corporation', division: 'Development', avatarBg: 'from-blue-500 to-blue-800' },
  { id: 'elara', name: 'Elara', avatar: 'E', status: 'online', role: 'MEMBER', badge: 'Foundation', division: 'Foundation', avatarBg: 'from-purple-500 to-purple-800' },
  { id: 'zin', name: 'Zin', avatar: 'Z', status: 'online', role: 'MEMBER', badge: 'Labs', division: 'Labs', avatarBg: 'from-cyan-500 to-cyan-800' },
];

export const useMemberStore = create((set, get) => ({
  members: [],

  currentUserId: 'anderson',

  setCurrentUser: (userId) =>
    set(() => ({
      currentUserId: userId,
    })),

  getCurrentUser: () => {
    const { members, currentUserId } = get();
    return members.find((m) => m.id === currentUserId);
  },

  updateMemberRole: (memberId, newRole) =>
    set((state) => ({
      members: state.members.map((m) =>
        m.id === memberId ? { ...m, role: newRole } : m
      ),
    })),

  kickMember: (memberId) =>
    set((state) => ({
      members: state.members.filter((m) => m.id !== memberId),
    })),

  banMember: (memberId) =>
    set((state) => ({
      members: state.members.map((m) =>
        m.id === memberId ? { ...m, status: 'banned' } : m
      ),
    })),

  timeoutMember: (memberId, durationMs) =>
    set((state) => ({
      members: state.members.map((m) =>
        m.id === memberId ? { ...m, timedOutUntil: Date.now() + durationMs } : m
      ),
    })),

  updateMemberStatus: (memberId, status, activity = '') =>
    set((state) => ({
      members: state.members.map((m) =>
        m.id === memberId ? { ...m, status, activity } : m
      ),
    })),

  setMembers: (membersList) => set({ members: membersList }),

  addMember: (member) =>
    set((state) => ({
      members: [...state.members, member],
    })),

  getOnlineMembers: () => {
    const { members } = get();
    return members.filter((m) => m.status !== 'offline' && m.status !== 'banned');
  },

  getMembersByRole: (role) => {
    const { members } = get();
    return members.filter((m) => m.role === role);
  },
}));
